import script from "./CourseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseTable.vue?vue&type=script&setup=true&lang=js"

import "./CourseTable.vue?vue&type=style&index=0&id=15919196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15919196"]])

export default __exports__